import { Component, Input } from "@angular/core";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { Ng1StateProxy } from "@gtmhub/shared/services/ng1-state.proxy";

@Component({
  selector: "gh-sub-nav-options",
  templateUrl: "./sub-nav-options.component.html",
  styleUrls: ["./sub-nav-options.component.less"],
})
export class SubNavOptionsComponent {
  @Input()
  public options: SubNavOption[];

  constructor(private ng1StateProxy: Ng1StateProxy) {}

  isActive(option: SubNavOption): boolean {
    return this.ng1StateProxy.getCurrentState() === option.state;
  }

  view(option: SubNavOption): void {
    this.ng1StateProxy.go(option.state, option.stateOptions);
  }
}
